import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import './i18n';
import i18n from './i18n';
// Service Worker 注册已移至 App 组件中，由 AdminContext 控制

// 确保跨域/代理场景下 Cookie 会话生效
axios.defaults.withCredentials = true;

// URL 语言前缀归一化（允许 /en-US，但内部只使用 /en）
const SUPPORTED_LANGS = ['ja', 'en', 'cn', 'tw'];
function normalizeLangLike(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  if (SUPPORTED_LANGS.includes(s)) return s;
  const lower = s.toLowerCase().replace('_', '-');
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (lower === 'ja' || lower.startsWith('ja-')) return 'ja';
  // 兼容旧写法：中文地区码/zh-* -> cn/tw
  if (lower === 'zh' || lower.startsWith('zh-') || lower === 'zh\u002dcn' || lower === 'zh\u002dtw') {
    if (lower.includes('tw') || lower.includes('hk') || lower.includes('hant')) return 'tw';
    return 'cn';
  }
  return null;
}

// 从 URL 前缀设置语言（/ja, /en, /cn, /tw）
// 约定：URL 语言前缀优先：访问 /cn 或 /tw 必须显示对应语言，并同步写入 localStorage，避免导航/内容语言不一致。
const rawPrefix = window.location.pathname.split('/').filter(Boolean)[0];
const prefix = normalizeLangLike(rawPrefix);
if (prefix) {
  // 等待 i18n 初始化完成后再检查，确保 localStorage 中的语言已经被读取
  const setLangFromUrl = () => {
    try {
      // 同步写入，确保后续 SPA 内跳转也保持一致
      localStorage.setItem('i18nextLng', prefix);
    } catch (_) {}
    if (i18n.language !== prefix) {
      i18n.changeLanguage(prefix);
    }
  };
  
  if (i18n.isInitialized) {
    setLangFromUrl();
  } else {
    i18n.on('initialized', setLangFromUrl);
  }
}

/**
 * 检测是否为静态页面
 * 通用规则：
 * 1. 路径以 .html 结尾（排除 /index.html 和根路径）
 * 2. 存在 #site-header 和 #site-footer 元素且有内容
 */
function isStaticPage() {
  const path = window.location.pathname;
  
  // 规则1：检查路径是否以 .html 结尾（排除 /index.html）
  // 匹配模式：/page.html 或 /lang/page.html
  const isHtmlPath = /\.html$/.test(path) && path !== '/index.html';
  
  // 规则2：检查是否存在 #site-header 和 #site-footer 元素且有内容
  const siteHeader = document.getElementById('site-header');
  const siteFooter = document.getElementById('site-footer');
  const hasStaticElements = siteHeader && siteFooter && 
    (siteHeader.children.length > 0 || siteFooter.children.length > 0);
  
  return isHtmlPath || hasStaticElements;
}

function bootstrapReact(){
  const mount = document.getElementById('root');
  if (!mount) return;
  
  // 检测静态页面：如果是静态页面，不应该被 React 应用接管
  if (isStaticPage()) {
    return;
  }
  
  const root = ReactDOM.createRoot(mount);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// 在 /view 环境中不自动启动，由桥接脚本显式调用，避免重复 createRoot()
if (window.location.pathname !== '/view') {
  // 延迟检查，等待 header.js 和 footer.js 加载完成
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(bootstrapReact, 100);
    });
  } else {
    setTimeout(bootstrapReact, 100);
  }
}

// 暴露给 view 的桥接脚本调用
window.__APP_BOOTSTRAP__ = bootstrapReact;